export type SocialPlatform = 'facebook' | 'instagram' | 'tiktok' | 'line';

const hasProtocol = (value: string) => /^https?:\/\//i.test(value);

export const normalizeExternalUrl = (value: string): string => {
  const trimmed = value.trim();
  return hasProtocol(trimmed) ? trimmed : `https://${trimmed}`;
};

export const normalizeSocialUrl = (value: string, platform: SocialPlatform): string => {
  const trimmed = value.trim();
  if (hasProtocol(trimmed)) return trimmed;

  // LINE has no fixed profile base URL (OA vs personal ID differ) — require a full URL, just add the protocol.
  if (platform === 'line') return `https://${trimmed}`;

  const id = trimmed.replace(/^[@/]+/, '');
  switch (platform) {
    case 'facebook':
      return `https://www.facebook.com/${id}`;
    case 'instagram':
      return `https://www.instagram.com/${id}`;
    case 'tiktok':
      return `https://www.tiktok.com/@${id}`;
    default:
      return `https://${trimmed}`;
  }
};
